import React from 'react';

export default function NubbiSquads() {
  return (
    <div style={{ padding: '2rem', backgroundColor: '#FFECEC', minHeight: '100vh', fontFamily: 'sans-serif' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
        <h1 style={{ fontSize: '2.8rem', fontWeight: 'bold', color: '#C62828', marginBottom: '1rem' }}>
          🚩 Nubbi Squads
        </h1>
        <p style={{ fontSize: '1.3rem', lineHeight: '1.8', color: '#333' }}>
          Get ready to build your ultimate team! Soon you'll be able to generate a <strong>team name</strong>, design a <strong>logo</strong>, create <strong>uniforms</strong>, invent a <strong>mascot</strong>, and showcase your squad with pride.
        </p>

        <div style={{ marginTop: '2rem', backgroundColor: '#ffffff', borderRadius: '16px', padding: '2rem', boxShadow: '0 0 15px rgba(0,0,0,0.1)' }}>
          <h2 style={{ color: '#B71C1C', fontSize: '1.5rem', marginBottom: '1rem' }}>👕 How will uniforms work?</h2>
          <p style={{ fontSize: '1.1rem', color: '#666' }}>
            You’ll be able to choose colors, upload your logo (or use our generator), and select between sports like Baseball, Soccer, eSports, and more.
            Each jersey will show your squad name, mascot patch, and number. Even merch options for your fans!
          </p>
        </div>

        <div style={{ marginTop: '2.5rem', backgroundColor: '#ffffff', borderRadius: '16px', padding: '2rem', boxShadow: '0 0 12px rgba(0,0,0,0.08)' }}>
          <h2 style={{ color: '#B71C1C', fontSize: '1.5rem', marginBottom: '1rem' }}>📸 Team Samples (Coming Soon)</h2>
          <p style={{ fontSize: '1rem', color: '#777' }}>
            Here you'll be able to see examples of real Nubbi Squads — with their uniforms, names and logos!
          </p>
          <div style={{ marginTop: '1rem', display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <div style={{ width: '160px', height: '160px', backgroundColor: '#FDD', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999' }}>
              Sample 1
            </div>
            <div style={{ width: '160px', height: '160px', backgroundColor: '#FDD', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999' }}>
              Sample 2
            </div>
            <div style={{ width: '160px', height: '160px', backgroundColor: '#FDD', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999' }}>
              Sample 3
            </div>
          </div>
        </div>

        <div style={{ marginTop: '3rem', fontStyle: 'italic', color: '#888' }}>
          Nubbi Squads are coming... and they’ll be legendary.
        </div>
      </div>
    </div>
  );
}